<template>
  <div class="MainContent">
    <!--    轮播图-->
    <el-carousel :interval="4000" type="card" height="300px">
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <a :href="item.href" target="_blank">
          <img :src="item.idView" class="image" alt="img" width="689px" height="300px">
        </a>
        <div class="desc">
          <h3>{{ item.content }}</h3>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="main_bottom">
      <div class="Countdown">
        <svg t="1623653070906" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="11680" width="200" height="200">
          <path
              d="M705.080889 174.842311C683.369244 21.674667 496.119467 0 496.119467 0c28.777244 152.300089-251.392 200.237511-308.946489 327.131022-57.554489 126.907733 63.1552 236.910933 63.1552 236.910933l167.034311-8.482133C503.643022 403.310933 733.858133 377.918578 705.080889 174.842311zM273.934222 505.8816c-7.981511-9.654044-17.937067-23.190756-26.498844-39.344356-22.124089-41.745067-24.888889-79.658667-8.450844-115.905422 17.171911-37.865244 74.715022-73.3184 130.363733-107.605333 45.582222-28.086044 92.714667-57.124978 127.937422-93.053156 24.069689-24.553244 40.661333-50.594133 49.706667-77.917867 7.375644 2.872889 15.032889 6.235022 22.704356 10.160356 47.007289 24.044089 72.868978 56.954311 79.058489 100.610844 5.865244 41.378133-1.555911 73.213156-24.052622 103.224889-23.045689 30.737067-59.969422 57.534578-99.063467 85.907911-47.852089 34.727822-101.216711 73.457778-140.3392 128.270222L273.934222 505.8816z"
              p-id="11681" data-spm-anchor-id="a313x.7781069.0.i36" class="selected" fill="#ffffff"></path>
          <path
              d="M654.111289 417.103644c-71.293156 34.312533-88.925867 53.302044-113.951289 83.911111-7.995733 9.7792-17.058133 20.866844-30.546489 34.5856l40.567467 39.881956c15.314489-15.579022 25.688178-28.268089 34.0224-38.462578 20.110222-24.598756 31.189333-38.149689 94.574933-68.656356 88.3456-42.510222 110.307556-93.1328 97.922844-225.6896l-56.644267 5.290667C731.337956 368.688356 712.066844 389.216711 654.111289 417.103644z"
              p-id="11682" data-spm-anchor-id="a313x.7781069.0.i37" class="selected" fill="#ffffff"></path>
          <path
              d="M796.626489 426.606933c-24.948622 52.283733-85.091556 78.270578-113.993956 90.757689-10.023822 4.329244-15.550578 6.715733-19.831467 9.998222l25.955556 33.865956c-0.221867 0.170667-0.480711 0.369778-0.802133 0.560356 1.501867-0.893156 7.102578-3.313778 11.599644-5.259378 33.672533-14.549333 103.736889-44.822756 135.5776-111.550578L796.626489 426.606933z"
              p-id="11683" data-spm-anchor-id="a313x.7781069.0.i38" class="selected" fill="#ffffff"></path>
          <path
              d="M735.698489 600.177778c-65.208889 0-194.437689 0-255.391289 0-61.8752 0-129.695289 0-191.544889 0-25.841778 0-30.458311 13.895111-7.148089 45.525333 28.817067 39.079822 54.741333 108.649244 76.276622 172.615111 1.408 4.178489 2.759111 8.621511 4.067556 13.073067 13.255111-16.310044 29.024711-33.649778 45.112889-45.434311C392.027022 742.070044 374.812444 696.888889 355.006578 657.066667l125.297778 0 165.660444 0c-23.648711 26.740622-43.465956 56.868978-59.081956 89.2928l-0.0768-0.082489c-8.1152 7.7312-47.886222 28.051911-105.6 50.486044-42.092089 16.352711-85.213867 81.700978-95.064178 97.328356-2.881422 4.124444-5.577956 8.126578-8.001422 11.875556 3.683556 12.728889 3.032178-0.992711-4.061867 60.700444C369.507556 1006.347378 426.837333 1024 486.033067 1024c64.591644 0 131.407644-21.006222 122.513067-57.335467-13.866667-56.635733-4.8384-200.109511 110.4128-301.929244C743.392711 643.154489 763.875556 600.177778 735.698489 600.177778zM486.033067 967.000178c-25.867378 0-44.032-3.953778-53.825422-7.569067 1.353956-11.153067 2.375111-18.784711 3.120356-24.354133 0.728178-5.447111 1.362489-10.259911 1.675378-14.907733 17.123556-26.1632 47.1296-63.5136 64.807822-70.382933 13.215289-5.137067 34.651022-13.735822 56.393956-23.580444-11.138844 45.451378-14.307556 92.677689-9.068089 131.5328C536.194844 962.247111 513.9456 967.000178 486.033067 967.000178z"
              p-id="11684" data-spm-anchor-id="a313x.7781069.0.i35" class="selected" fill="#ffffff"></path>
        </svg>
        <span class="svgSplit"></span>
        <svg t="1623652195526" class="icon" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="2616" width="200" height="200">
          <path
              d="M945.791327 648.893557v-14.498699q0-2.001863 0.201371-5.042167h-0.122402a25.949196 25.949196 0 0 1-0.742308 3.067944l-5.891083 16.472922h-4.059004l-5.970052-16.318933a32.98138 32.98138 0 0 1-0.754154-3.221933h-0.142144q0.201371 3.008717 0.201371 6.029279v13.511587h-4.595993v-23.892055h7.403339l5.132981 14.435523a17.503467 17.503467 0 0 1 0.880504 3.364078h0.106608q0.481711-1.974224 0.987112-3.391717l5.164569-14.407884h7.205916v23.892055h-5.030321z m-31.942939 0h-5.105342v-19.742237h-6.799226v-4.165612h18.723537v4.165612h-6.811072v19.742237z m-62.772415 39.484473c8.461523 0 38.919845-6.203011 59.22671 19.742236-8.461523-0.564628-73.326615-7.332267-94.762736 15.79379-5.642331-1.129256-13.539226-11.845342-15.793789-19.742237-5.077703 0-41.739037-6.203011-63.175157 15.793789-4.513075-3.383819-15.793789-19.742237-15.793789-19.742236s45.126804-37.790589 55.278262-55.278263c0-3.948447-7.896895-3.948447-7.896894-3.948447h-3.948448s-18.612981 5.077703-23.690684 11.845342c-3.948447-1.129256-10.716086-2.819191-11.845342-19.742236-0.454071-6.799226 32.716834-10.716086 51.329815-7.896895s15.793789 16.358417 11.845342 23.690684-23.126056 31.022951-23.690683 35.536026 25.384568-6.767639 39.484473 11.845342c11.845342-10.716086 43.997548-40.613729 43.43292-43.432921s-0.564628-9.590779-35.536026 3.948447c-3.948447-1.129256-15.229161-19.177609 3.948448-23.690683s59.791338-9.590779 55.278262 11.845341c-1.693884 12.974598-25.384568 37.22991-23.690684 43.432921z m-146.092551-414.586968c-24.677796 2.961335-197.422366-25.664908-272.442864-19.742237-21.71646 4.935559-127.337426 34.548914-185.577024 90.814289-8.884006-7.896895-23.690684-26.652019-35.536026-39.484474 21.71646-11.845342 258.623299-213.216155 544.88573-157.937892-2.961335 3.948447-145.105439-17.768013-256.649076 47.381368 11.845342 2.961335 151.02811 12.832454 217.164602 11.845342 15.793789-1.974224 37.510249-3.948447 47.381368-31.587579 2.961335 16.780901-14.806677 75.020499-59.22671 98.711183z m-367.181909-90.735319c37.822177-35.879541 78.945256-67.202573 78.945256-67.202574l-39.484474 3.948448s-34.548914-42.445809-39.484473-51.329815c52.316927-40.471585 179.547745-75.901003 165.834788-67.123605-24.677796 15.793789-47.381368 35.536026-67.123605 51.329815 30.600467-9.871118 98.711183 3.948447 98.711183 3.948448s22.703572 33.561802 35.536026 55.278262c-124.37609 12.832454-307.97889 150.040998-307.978891 150.040998s35.891386-41.746933 75.04419-78.889977z m-98.734874 461.889366h-35.536025l-3.948448 19.742237s27.639131 0.564628 31.587579 0 0 15.793789 0 15.793789h-39.484473s-7.896895 16.923045-3.948448 19.742237c7.896895 0.564628 39.484473 0 39.484474 0s5.642331 3.383819 3.948447 15.793789c-3.948447 0.564628-51.329815 0-51.329815 0s-13.539226-9.026151-11.845342-19.742236c2.254563-10.716086 19.742237-65.994348 23.690684-67.123605s40.049101-0.564628 43.43292 0 6.767639 8.461523 3.948447 15.793789z m-75.020498 39.484474c-18.952547 36.325715-55.278262 31.587579-75.020499 31.587578-18.952547 2.369068-11.845342-7.896895-11.845342-7.896895s21.321615-60.806089 23.690684-67.123604a53.398801 53.398801 0 0 0-15.79379 3.948447l-7.896894-19.742236c10.151458-3.044253 66.44842-8.911646 82.917393 3.948447 9.191985 7.174329-6.317516 30.0082-7.896894 35.536026 4.738137 4.738137 12.635031 11.055652 11.845342 19.742237z m-39.484474-15.79379c-1.129256-3.948447-9.026151-9.026151 3.948448-15.793789s21.9968-7.896895 15.793789-15.793789h-23.690684s-13.539226 36.665282-15.793789 59.22671c6.203011 1.129256 43.43292 0 47.381368-15.79379-1.129256-5.077703-16.358417-10.716086-27.639132-11.845342z m142.144104-39.484473h15.793789v11.845342l-19.742237 75.020499h-23.690684s10.151458-51.329815 27.639132-86.865841z m7.896894 118.45342a20.196308 20.196308 0 0 1-27.639131-3.948448c6.767639-1.129256 16.358417 0.564628 23.690684-19.742236s23.690684-75.585127 27.639131-94.762736h23.690684s-20.871492 111.685781-47.381368 118.45342z m39.484473-31.587579s10.151458-51.329815 27.639132-86.865841h15.793789v11.845342l-19.742237 75.020499h-23.690684z m86.865841 0l-11.845342-47.381368h-7.896894s-6.203011 37.790589-7.896895 47.381368c-5.077703-0.564628-19.742237 0-19.742236 0s0-36.665282 23.690683-86.865841h19.742237s6.203011 42.868292 11.845342 51.329815c3.948447-6.203011 12.974598-44.562176 19.742237-51.329815h19.742236a326.536593 326.536593 0 0 0-23.690684 86.865841 155.568824 155.568824 0 0 1-23.690684 0z m55.278263 0c-31.587579-9.026151-21.43612-41.178357 0-67.123604s48.565902-19.990989 63.175157-19.742237c6.203011 19.742237 1.129256 18.612981-15.793789 19.742237-33.842142 0.564628-49.075252 25.945247-55.278263 39.484473-4.513075 15.229161 18.612981 11.845342 23.690684 11.845342 8.461523-3.948447 24.81994-20.306865 31.587579-23.690684 8.461523 1.129256 15.793789 7.896895 15.793789 15.793789s-14.664533 28.203759-23.690684 35.536026a23.102365 23.102365 0 0 1-23.690684 0 21.858604 21.858604 0 0 1 0-7.896895c12.40997 1.129256 15.793789-3.948447 15.793789-3.948447a9.9185 9.9185 0 0 0 0-7.896895c-8.461523 6.203011-19.177609 7.896895-31.587578 7.896895z m75.020499-157.937892c-9.871118-1.974224-125.363202-50.342703-177.680129-169.783235 13.819566-9.871118 74.033387-41.458697 98.711182-47.381368-16.780901-6.909783-54.291151-26.652019-185.577023 0-18.782764 3.8142 137.208544-84.891617 307.97889-27.639131-4.935559 5.922671-106.608077 52.316927-150.040998 118.45342 5.922671 6.909783 79.956058 48.36848 153.989445 67.123604-9.871118 13.819566-37.510249 48.36848-47.381367 59.22671z m110.556524 134.247208c0.564628-5.077703 5.642331-52.459071 51.329816-63.175157 11.845342 1.693884 33.281462 3.948447 31.587578 35.536026-3.948447 22.561428-19.742237 45.687484-35.536026 55.278262s-37.22991-7.332267-43.43292-15.793789a128.85363 128.85363 0 0 0-71.072052 19.742237 227.035721 227.035721 0 0 0-15.793789-23.690684s51.329815-28.203759 59.22671-55.278263a52.076072 52.076072 0 0 0-39.484474 11.845342c-5.077703-3.948447-10.151458-9.026151-7.896894-23.690683 5.484393-4.896075 38.919845-6.203011 51.329815-3.948448 11.280714 2.254563 19.742237 7.896895 11.845342 23.690684a251.824073 251.824073 0 0 1-23.690684 35.536026s23.126056-0.564628 31.587578 3.948447z m27.639132 15.793789c5.642331 0.564628 35.536026-24.255312 35.536025-31.587578s3.383819-36.665282-7.896894-35.536026c-5.081652 0.50935-24.81994 15.793789-31.587579 27.639131s-2.819191 37.790589 3.948448 39.484473z m-359.308706 71.072052a82.917394 82.917394 0 0 1 82.826579 79.363791c2.629666-0.252701 5.290919-0.394845 7.987709-0.394845s5.358043 0.138196 7.987709 0.394845a82.917394 82.917394 0 0 1 165.653159 0c2.629666-0.252701 5.290919-0.394845 7.987709-0.394845 1.358266 0 2.704686 0.039484 4.047158 0.10266a82.917394 82.917394 0 1 1 82.818683 86.763181c-1.358266 0-2.704686-0.039484-4.047159-0.102659a82.917394 82.917394 0 0 1-165.645262-0.288237c-2.629666 0.252701-5.290919 0.394845-7.987708 0.394845s-5.358043-0.138196-7.987709-0.394845a82.917394 82.917394 0 0 1-165.653159 0c-2.629666 0.252701-5.290919 0.394845-7.987709 0.394845a82.917394 82.917394 0 0 1 0-165.838736z m359.308706 153.989445a71.072052 71.072052 0 1 0-70.94965-73.476656 82.95293 82.95293 0 0 1 66.606358 73.255543c1.441183 0.090814 2.87447 0.221113 4.343292 0.221113z m-70.282363-61.153552a71.028619 71.028619 0 0 0 53.738368 59.131947 71.028619 71.028619 0 0 0-53.738368-59.131947z m-16.583478 140.122499a71.020722 71.020722 0 0 0 70.94965-68.667448 82.95293 82.95293 0 0 1-66.606358-73.255543c-1.445132-0.090814-2.878418-0.221113-4.343292-0.221113a71.399773 71.399773 0 0 0-8.319379 0.529092 82.980569 82.980569 0 0 1-62.673704 72.090751 71.028619 71.028619 0 0 0 70.993083 69.524261z m-20.67407-139.068263a71.091794 71.091794 0 0 0-49.466148 57.023476 71.091794 71.091794 0 0 0 49.466148-57.023476z m-70.140218 60.099316a71.399773 71.399773 0 0 0 8.319378-0.529092 82.980569 82.980569 0 0 1 62.673704-72.090751 71.008876 71.008876 0 0 0-141.986165 0 82.980569 82.980569 0 0 1 62.673704 72.090751 71.399773 71.399773 0 0 0 8.319379 0.529092z m-70.140219-60.099316a71.091794 71.091794 0 0 0 49.466148 57.023476 71.091794 71.091794 0 0 0-49.466148-57.023476z m-20.67407 139.068263a71.028619 71.028619 0 0 0 70.993083-69.524261 82.980569 82.980569 0 0 1-62.673704-72.090751 65.670576 65.670576 0 0 0-16.638757 0 82.97662 82.97662 0 0 1-62.673704 72.090751 71.032567 71.032567 0 0 0 70.993082 69.524261z m-20.67407-139.068263a71.072052 71.072052 0 0 0-49.466148 57.023476 71.072052 71.072052 0 0 0 49.466148-57.023476z m-70.140218 60.099316a71.443206 71.443206 0 0 0 8.319379-0.529092 82.972672 82.972672 0 0 1 62.673704-72.090751 71.040464 71.040464 0 1 0-70.993083 72.619843z"
              p-id="2617" fill="#ffffff"></path>
        </svg>
        <ul class="ul1">
          <li>天</li>
          <li>小时</li>
          <li>分钟</li>
          <li>秒</li>
        </ul>
        <ul class="ul2">
          <li>{{ showTime.d }}</li>
          <li>{{ showTime.h }}</li>
          <li>{{ showTime.m }}</li>
          <li>{{ showTime.s }}</li>
        </ul>
        <h2>距离北京冬奥会开幕还有</h2>
      </div>
      <div class="main_middle">
        <a href="#/Introduction">
          <img src="https://i.loli.net/2021/06/14/HySlnDIswv8CeaQ.png" alt="赛程介绍" height="120px"/>
        </a>
        <a target="_blank" href="https://www.beijing2022.cn/cn/presscentre/officialrelease.htm">
          <img src="https://img1.gtimg.com/bj2022/pics/hv1/87/202/2325/151234722.png" alt="官方发布" height="120px" />
        </a>
      </div>
      <div class="main_right">
        <Schedule></Schedule>
      </div>
    </div>
  </div>
</template>

<script>
import Schedule from "./Schedule";
export default {
  name: "MainContent",
  components: {Schedule},
  data() {
    return {
      imgList: [
        {
          id: 0, idView: 'https://img1.gtimg.com/ninja/2/2021/01/ninja161106114732204.jpg',
          content: '习近平在北京河北考察并主持召开北京2022年冬奥会和冬残奥会筹办工作汇报会',
          href: 'https://www.beijing2022.cn/a/20210120/012730.htm'
        },
        {
          id: 1, idView: 'https://img1.gtimg.com/ninja/2/2021/02/ninja161244199182507.jpg',
          content: '北京冬奥会迎来倒计时一周年',
          href: 'https://www.beijing2022.cn/a/20210204/011147.htm'
        },
        {
          id: 2, idView: 'https://img1.gtimg.com/ninja/2/2021/02/ninja161244191444342.jpg',
          content: '北京冬奥会和冬残奥会火炬诞生记',
          href: 'https://www.beijing2022.cn/a/20210204/011270.htm'
        },
        {
          id: 3, idView: 'https://img1.gtimg.com/ninja/2/2021/02/ninja161244192422545.jpg',
          content: '北京2022年冬奥会和冬残奥会火炬宣传片',
          href: 'https://www.beijing2022.cn/a/20210204/011219.htm'
        }
      ],
      // date: new Date(),
      showTime: {
        d: '',
        h: '',
        m: '',
        s: ''
      }
    }
  },
  mounted() {
    this.getDate()
  },
  methods: {
    getDate() {
      //获取当前时间
      const date = new Date();
      // const date = this.date;
      const now = date.getTime();
      //设置截止时间
      const str = "2022/02/04 20:00:00";
      const endDate = new Date(str);
      const end = endDate.getTime();

      //时间差
      const leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.showTime.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.showTime.h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        this.showTime.m = Math.floor(leftTime / 1000 / 60 % 60);
        this.showTime.s = Math.floor(leftTime / 1000 % 60);
      }
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.getDate, 1000);
      console.log(this.showTime)
    }
  }
}
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.el-carousel {
  position: relative;
}

.el-carousel__item h3 {
  color: #fff;
  font-size: 16px;
  text-align: left;
  width: 60%;
  //opacity: 0.75;
  margin: 0;
  padding-bottom: 5px;
  position: relative;
}

.desc {
  width: 100%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, .6) 0, rgba(0, 0, 0, .4) 30%, rgba(0, 0, 0, .2) 50%, transparent);
}

.main_bottom {
  display: flex;
  justify-content: space-between;
  position: relative;
  //bottom: -10px;
  margin-top: 20px;

  .Countdown {
    position: relative;
    width: 400px;
    height: 260px;
    border-radius: 18px;
    background-image: url(https://mat1.gtimg.com/qqcdn/bj2022/countdown/img/bg_countdown_white.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-shadow:
        0 2.8px 2.2px rgba(0, 0, 0, 0.02),
        0 6.7px 5.3px rgba(0, 0, 0, 0.028),
        0 12.5px 10px rgba(0, 0, 0, 0.035),
        0 22.3px 17.9px rgba(0, 0, 0, 0.042),
        0 41.8px 33.4px rgba(0, 0, 0, 0.05),
        0 100px 80px rgba(0, 0, 0, 0.07)
  ;


    svg {
      position: relative;
      top: 2%;
      width: 40%;
      height: 40%;

    }

    .svgSplit {
      border: 1px solid black;
      height: 100%;
    }

    ul {
      display: flex;

      li {
        position: relative;
        flex: 1;
        text-align: center;
      }
    }

    .ul1 {
      font-size: 1rem;
      color: #536199;
      margin-bottom: 0;
    }

    .ul2 {
      font-size: 2rem;
      margin-top: 0;
      color: #103c99;
      font-weight: bold;
    }

    h2 {
      position: absolute;
      display: flex;
      left: 15%;
      text-align: center;
      bottom: 0;
      color: #fff;
    }
  }
  .main_middle{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .main_right {
    position: relative;
    width: 380px;
    height: 260px;
    border-radius: 5px;
    box-shadow:
        0 2.8px 2.2px rgba(0, 0, 0, 0.02),
        0 6.7px 5.3px rgba(0, 0, 0, 0.028),
        0 12.5px 10px rgba(0, 0, 0, 0.035),
        0 22.3px 17.9px rgba(0, 0, 0, 0.042),
        0 41.8px 33.4px rgba(0, 0, 0, 0.05),
        0 100px 80px rgba(0, 0, 0, 0.07)
  ;

    background-color: #eee;
    overflow: auto;
    /*隐藏滚动条而不影响功能,适配火狐和IE*/
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .main_right::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }

}

</style>